/**
 * This script should be called once (e.g. on the main layout), and it will
 * apply to all elements with data-toggle set.
 * 
 * @usage <button data-toggle="id-of-element">Something</button>
 */
document.querySelectorAll('[data-toggle]').forEach((toggle) => {
    if (!toggle.hasAttribute('aria-expanded')) {
        toggle.setAttribute('aria-expanded', 'false')
    }

    toggle.addEventListener('click', () => {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true'
        const newState = !isExpanded
        toggle.setAttribute('aria-expanded', newState.toString())

        toggle.classList.toggle('toggle-expanded', newState)
        document.querySelector(`#${toggle.dataset.toggle}`).classList.toggle('toggle-expanded', newState)
    })
})
